import { putSelectionsVehicleGroupVolume } from '@/containers/CampaignDetail/AffectedVehicles/Volume/VolumeDetails/VehicleCleanDirt/VehicleCleanDirt-utils';
import { getOriginValuesNewState } from '@/containers/CampaignDetail/AffectedVehicles/Volume/VolumeDetails/volumeDetails-utils';
import { LOADING } from '@/helpers/constants';
import { arrayMove, isVansBeforeFlowRemoval } from '@/helpers/utils';
import { addPlantsNotInVolumes, uniqueSeriesPlants } from './campaign.utils';
import {
  MODIFY_CAMPAIGN_HELP, MODIFY_CAMPAIGN_INFO, MODIFY_CAMPAIGN_ATTACHMENTS,
  MODIFY_CAMPAIGN_CLASSIFICATION, MODIFY_CAMPAIGN_HARDWARE, MODIFY_CAMPAIGN_SOFTWARE, MODIFY_CAMPAIGN_VEHICLES,
  MODIFY_CAMPAIGN_RECIPIENTS, UPDATE_CAMPAIGN_INFO, MODIFY_ORIGINAL_VALUES,
  MODYFY_CAMPAIGN, SET_VALIDATIONS, SET_ACTIVE_VALIDATIONS_MIN, SET_CLASSIFICATION_VALIDATIONS,
  SET_RECIPIENTS_VALIDATIONS, SET_AFFECTED_VEHICLES_VOLUMES, MODIFY_AFFECTED_VEHICLES_SERIES,
  SET_AFFECTED_VEHICLES_VALIDATIONS, MODIFY_CAMPAIGN_SUMMARY, ADD_CAMPAIGN_ATTACHMENTS, SET_CAMPAIGN_HISTORY,
  DELETE_CAMPAIGN_ATTACHMENT, TOGGLE_ATTACHMENT_FAVORITE, UPDATE_ATTACHMENT_FIELD, ADD_AFTER_QMB_ATTACHMENTS,
  TOGGLE_CAMPAIGN_HISTORY, COPY_VEHICLES_MODEL_DESIGNATION, COPY_AGGREGATE, ADD_PLANT_ATTACHMENTS, ADD_SELECTED_PLANT,
  SET_ONLY_PLANTS, SET_SELECTED_AFFECTED_VEHICLES, SET_CAMPAIGN_TRANSLATIONS, SET_TRANSLATION_VALIDATIONS, SET_TRANSLATIONS,
  SET_VOLUMES_AND_ORIGIN_CHANGE, COPY_PLANT_ATTACHMENTS, SET_AFFECTED_PLANTS,
  MODIFY_CAMPAIGN_VEHICLES_ASSESSMENT, DELETE_PLANT_ATTACHMENTS, UPDATE_PLANT, RESET_CAMPAIGN, SET_PENDING_VOLUMES,
  SET_SOFTWARE_VALIDATIONS, MODIFY_CAMPAIGN_PLANTFEEDBACK, SET_LIMITATION_PLANTS, SET_VEHICLE_GROUPS, SET_CAMPAIGN_CHANGES,
  SET_CAMPAIGN_SEARCH, SET_CAMPAIGN_SEARCH_SELECTED_COINCIDENCE_FIELD_ID, MODIFY_CAMPAIGN_DESCRIPTION,
  SET_DESCRIPTION_VALIDATIONS, MODIFY_CAMPAIGN_RISK_SCE_RELEVANCY, SET_HIGHLIGHT_TAB,
} from '../types';

const initialState = () => ({
  originalValues: {
    hasChange: false,
    changesIn: {},
    values: {
      id: '',
      version: 0,
      source: '',
      failureOccurredOn: '',
      triggerComment: {},
      problems: {},
      inspectionType: [],
      inspectionComment: {},
      referencedSystem: '',
      referencedSystemName: '',
      iraNumber: '',
      contactPerson: { code: '', department: '', summary: '' },
      locationInternalIsChosen: true,
      locationInternal: {
        possibleCauser: { code: '', department: '', summary: '' },
        costCenter: '',
      },
      locationExternal: {
        contactPersonSupplierManagement: { code: '', department: '', summary: '' },
        costTakeOverAgreedOn: '',
        supplier: '',
        supplierAddress: {},
        costCoverageAcknowledged: false,
        additionalContactPerson: { code: '', department: '', summary: '' },
        tier1SupplierAcknowledged: false,
      },
      plants: [],
      comment: {},
    },
  },
  help: {
    show: true,
    focus: null,
    invalidLanguages: [],
  },
  history: {
    show: false,
    statuses: [],
  },
  info: {
    id: '',
    version: 0,
    versionDate: '',
    creationDate: '',
    creationSystem: '',
    defaultLanguage: '',
    status: '',
    statusDate: '',
    statusUserCode: '',
    statusUserRole: '',
    successfulStatuses: [],
    doormanSelected: false,
    partCode: '',
    recipientsDate: '',
    typeOfErrorCode: '',
    activeLanguages: [],
    assignedUser: { code: '', department: '', summary: '' },
    authorization: {
      asRepresentative: false,
      campaignRole: '',
      kindOfPermission: '',
      readOnly: false,
    },
    contactPerson: { code: '', department: '', summary: '' },
    creationUser: { code: '', department: '', summary: '' },
    recipients: {},
    statusComment: {},
    title: {},
    type: '',
    riskPotentiallyRelevant: false,
    fieldsWhereTextWasFound: [],
    fieldsWhereTextWasFoundCounter: 0,
  },
  description: {
    id: '',
    version: 0,
    failureOccurredOn: '',
    source: '',
    inspectionComment: {},
    inspectionType: [],
    triggerComment: {},
    buildUpApproval: {},
    problems: {},
    comment: {},
    contactPerson: { code: '', department: '', summary: '' },
    iraNumber: '',
    locationInternalIsChosen: false,
    referencedSystem: '',
    referencedSystemName: '',
    plants: [],
    locationInternal: {
      costCenter: '',
      possibleCauser: { code: '', department: '', summary: '' },
    },
    locationExternal: {
      contactPersonSupplierManagement: { code: '', department: '', summary: '' },
      costTakeOverAgreedOn: '',
      supplier: '',
      supplierAddress: {},
      costCoverageAcknowledged: false,
      additionalContactPerson: { code: '', department: '', summary: '' },
      tier1SupplierAcknowledged: false,
    },
  },
  attachments: {},
  classification: {
    id: '',
    version: 0,
    customerRelevanceChosen: false,
    potentiallySCECertificationRelevant: [],
    customerRelevance: '',
    relevanceComment: {},
    affectsChina: '',
    crashCertificationVehicles: '',
    developmentVehiclePooling: '',
  },
  affectedHardware: {
    id: '',
    version: 0,
    switchWithoutPartChange: false,
    switchWithPartChange: false,
    partAvailability: {
      cocPaperRelated: false,
      ioPartsAvalaibleFrom: '',
      ioIdentification: {},
    },
    partWithChange: [],
    partWithoutChange: [],
    lastModification: '',
  },
  affectedSoftware: {
    id: '',
    coding: false,
    flashing: false,
    doormanSelected: false,
    otaUpdate: '',
    otaComment: {},
    mbosDetails: {
      isMbos: '',
      releaseFlashable: '',
      stillFlashable: '',
    },
    flashingInformation: {
      sfmRequested: '',
      sfm: [],
    },
    eeCommissioningRequired: false,
    codingParts: [],
    codingUuids: [],
    flashingParts: [],
    flashingUuids: [],
    doormanParts: [],
    doormanUuids: [],
    version: 0,
  },
  affectedVehicles: {
    typeOfAffectedPlantsSelection: 'SERIES',
    technicalAssessment: {},
    volumes: [],
    series: [],
    affectedPlants: [],
    lastMSAdded: false,
  },
  limitationPlants: {},
  copyVehicleModelDesignation: {},
  copyAggregate: {},
  recipients: {
    id: '',
    version: 0,
    approvalWorkflow: '',
    approvalWorkflowStatuses: [],
    responsibleRequester: { code: '', department: '', summary: '' },
    standIn: { code: '', department: '', summary: '' },
    approvers: {
      E3C: { code: '', department: '', summary: '' },
      E4C: { code: '', department: '', summary: '' },
      E2C: { code: '', department: '', summary: '' },
      E3I: { code: '', department: '', summary: '' },
      E4I: { code: '', department: '', summary: '' },
      E2I: { code: '', department: '', summary: '' },
    },
    causerCheckApprover: { code: '', department: '', summary: '' },
    causerPreApprover: { code: '', department: '', summary: '' },
    causerApprover: { code: '', department: '', summary: '' },
    commentsApproverCauser: '',
    informerCheckApprover: { code: '', department: '', summary: '' },
    informerPreApprover: { code: '', department: '', summary: '' },
    informerApprover: { code: '', department: '', summary: '' },
    commentsApproverInformer: '',
    campaignManager: { code: '', department: '', summary: '' },
    rdCampaignManager: { code: '', department: '', summary: '' },
    commentsRdCampaignManager: '',
    e3ChiefEngineer: { code: '', department: '', summary: '' },
    e3QMBApprover: {},
    e2QMBInformer: { code: '', department: '', summary: '' },
    vanCommitteeCoordinator: { code: '', department: '', summary: '' },
  },
  translations: {
    id: '',
    defaultLanguage: '',
    modules: {},
    affectedVehicles: {
      translatablePropertiesByPlant: [],
    },
  },
  summary: {},
  plantFeedback: {},
  validations: {},
  changesFromVersion: {
    versionToCompare: null,
    active: false,
    description: {},
    classification: {},
    recipients: {},
    affectedVehicles: {},
    affectedSoftware: {},
    affectedHardware: {},
  },
  campaignSearch: {
    active: false,
    fieldSelected: null,
    resultCounter: 0,
    searchedText: '',
    sections: {},
    selectedCoincidenceFieldId: null,
    results: [],
  },
});

export default (state = initialState, action) => {
  let newState = {};

  switch (action.type) {
    case MODIFY_CAMPAIGN_HELP:
      newState = { help: action.payload };
      break;
    case SET_CAMPAIGN_HISTORY:
      newState = { history: { ...state.history, ...action.payload } };
      break;
    case TOGGLE_CAMPAIGN_HISTORY: {
      const show = action.payload;
      newState = { history: { ...state.history, show } };
      break;
    }
    case UPDATE_CAMPAIGN_INFO:
      newState = { info: action.payload };
      break;
    case MODIFY_CAMPAIGN_INFO:
      newState = { ...initialState, info: action.payload, help: { ...initialState.help, show: action.payload.status === 'IN_CREATION' } };
      break;
    case MODIFY_CAMPAIGN_DESCRIPTION:
      newState = { description: action.payload };
      break;
    case MODIFY_CAMPAIGN_ATTACHMENTS:
      newState = { attachments: action.payload };
      break;
    case ADD_CAMPAIGN_ATTACHMENTS: {
      const attachments = [...state.attachments.attachments];

      action.payload.forEach((att) => {
        const item = state.attachments.attachments.find((a) => a.fullName === att.fullName && a.status === LOADING);
        const id = state.attachments.attachments.indexOf(item);

        if (item) {
          attachments[id] = {
            ...attachments[id],
            ...att,
          };
        } else {
          attachments.push(att);
        }
      });

      newState = {
        attachments: {
          ...state.attachments,
          attachments,
        },
      };
      break;
    }

    case DELETE_CAMPAIGN_ATTACHMENT: {
      const filterById = (list) => (list || []).filter((a) => a.id !== action.payload);
      const isInAfter = state.attachments?.subCampaignAttachments?.attachments?.some((attachment) => attachment.id === action.payload);
      newState = {
        attachments: {
          ...state.attachments,
          ...(isInAfter ? {} : { attachments: filterById(state.attachments.attachments) }),
          ...(state.attachments.subCampaignAttachments && isInAfter
            ? {
              subCampaignAttachments: {
                ...state.attachments.subCampaignAttachments,
                attachments: filterById(state.attachments.subCampaignAttachments.attachments),
              },
            }
            : {}),
        },
      };
      break;
    }

    case TOGGLE_ATTACHMENT_FAVORITE: {
      const toggleFav = (list) => (list || []).map((a) => ({
        ...a,
        favorite: a.id === action.payload ? !a.favorite : false,
      }));
      const isInAfter = state.attachments?.subCampaignAttachments?.attachments?.some((attachment) => attachment.id === action.payload);
      newState = {
        attachments: {
          ...state.attachments,
          attachments: isInAfter ? state.attachments.attachments : toggleFav(state.attachments.attachments),
          ...(state.attachments.subCampaignAttachments && isInAfter
            ? {
              subCampaignAttachments: {
                ...state.attachments.subCampaignAttachments,
                attachments: toggleFav(state.attachments.subCampaignAttachments.attachments),
              },
            }
            : {}),
        },
      };
      break;
    }

    case UPDATE_ATTACHMENT_FIELD: {
      const { attachmentId, changes } = action.payload;
      const applyChanges = (list) => (list || []).map((item) => (item.id === attachmentId ? { ...item, ...changes } : item));
      const isInAfter = state.attachments?.subCampaignAttachments?.attachments?.some((attachment) => attachment.id === attachmentId);
      newState = {
        attachments: {
          ...state.attachments,
          attachments: isInAfter ? state.attachments.attachments : applyChanges(state.attachments.attachments),
          ...(state.attachments.subCampaignAttachments && isInAfter
            ? {
              subCampaignAttachments: {
                ...state.attachments.subCampaignAttachments,
                attachments: applyChanges(state.attachments.subCampaignAttachments.attachments),
              },
            }
            : {}),
        },
      };
      break;
    }

    case ADD_AFTER_QMB_ATTACHMENTS: {
      newState = {
        attachments: {
          ...state.attachments,
          subCampaignAttachments: {
            ...state.attachments.subCampaignAttachments,
            attachments: [
              ...(state.attachments.subCampaignAttachments?.attachments || []),
              ...action.payload,
            ],
          },
        },
      };
      break;
    }

    case ADD_PLANT_ATTACHMENTS: {
      const newVolumes = JSON.parse(JSON.stringify(state.affectedVehicles?.volumes));
      const plant = state.affectedVehicles?.volumes
        .find((currentVolume) => currentVolume.plant === action.payload?.plant);
      const attachments = [...plant.vehicleRestrictionFiles];
      action.payload.files.forEach((att) => {
        const item = plant.vehicleRestrictionFiles?.find((file) => file.fullName === att.fullName && file.status === LOADING);
        const id = plant.vehicleRestrictionFiles?.indexOf(item);

        if (item) {
          attachments[id] = {
            ...attachments[id],
            ...att,
          };
        } else {
          attachments.push(att);
        }
      });
      const plantIndex = state.affectedVehicles.volumes
        .findIndex((currentVolume) => currentVolume.plant === action.payload?.plant);
      newVolumes[plantIndex].vehicleRestrictionFiles = attachments;
      newVolumes[plantIndex].fileOptionSelected = true;
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          volumes: newVolumes,
        },
        originalValues: {
          ...state.originalValues,
          values: {
            ...state.originalValues.values,
            volumes: newVolumes,
          },
          hasChange: true,
          changesIn: {
            ...state.originalValues?.changesIn,
            volumes: {
              ...state.originalValues.changesIn?.volumes,
              [newVolumes[plantIndex].plant]: true,
            },
          },
        },
      };
      break;
    }

    case DELETE_PLANT_ATTACHMENTS: {
      const plantIndex = state.affectedVehicles.volumes?.findIndex((currentVolume) => (
        currentVolume.plant === action.payload?.wkz));
      const newFiles = state.affectedVehicles?.volumes[plantIndex]?.vehicleRestrictionFiles?.filter((attachments) => (
        attachments.id !== action.payload?.file));
      const attachments = [...state.affectedVehicles.volumes];
      attachments[plantIndex] = {
        ...attachments[plantIndex],
        vehicleRestrictionFiles: newFiles,
      };
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          volumes: attachments,
        },
        originalValues: {
          ...state.originalValues,
          values: {
            ...state.originalValues.values,
            volumes: attachments,
          },
        },
      };

      break;
    }

    case COPY_PLANT_ATTACHMENTS: {
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          volumes: action.payload,
        },
        originalValues: {
          ...state.originalValues,
          values: {
            ...state.originalValues.values,
            volumes: action.payload,
          },
        },
      };
      break;
    }

    case MODIFY_CAMPAIGN_CLASSIFICATION:
      newState = { classification: action.payload };
      break;
    case MODIFY_CAMPAIGN_HARDWARE:
      newState = { affectedHardware: action.payload };
      break;
    case MODIFY_CAMPAIGN_SOFTWARE:
      newState = { affectedSoftware: action.payload };
      break;
    case MODIFY_CAMPAIGN_VEHICLES: {
      let { series } = action.payload;

      if (state.affectedVehicles?.lastMSAdded) {
        series = arrayMove(series, series.findIndex((ms) => (ms.serie === ''
          || ms.serie === state.affectedVehicles?.lastMSAdded)), series.length - 1);
      }

      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          ...action.payload,
          series,
        },
      };
      break;
    }
    case MODIFY_CAMPAIGN_VEHICLES_ASSESSMENT:
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          technicalAssessment: action.payload,
        },
      };
      break;
    case MODIFY_AFFECTED_VEHICLES_SERIES: {
      const newSeries = action.payload;
      let filteredSeries = newSeries.filter(({ serie, typeVersions }) => !(serie && Object.keys(typeVersions).length === 0));
      let lastMSAdded = false;
      const oldSeriesWithoutBlank = state.affectedVehicles?.series?.filter((ms) => ms.serie !== '').map((se) => se.serie);
      const newSeriesWithoutBlank = filteredSeries.filter((ms) => ms.serie !== '').map((se) => se.serie);
      const indexBlankInNew = filteredSeries.findIndex(({ serie }) => (serie === ''));

      if (newSeriesWithoutBlank.length > oldSeriesWithoutBlank.length) {
        lastMSAdded = newSeriesWithoutBlank.filter((ms) => !oldSeriesWithoutBlank.includes(ms))?.[0];
      } else if (state.affectedVehicles?.lastMSAdded && indexBlankInNew === -1) {
        const indexToChange = filteredSeries.findIndex(({ serie }) => (serie === state.affectedVehicles?.lastMSAdded));
        filteredSeries = arrayMove(filteredSeries, indexToChange, filteredSeries.length - 1);
      }

      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          series: filteredSeries,
          volumes: addPlantsNotInVolumes(
            state.affectedVehicles?.volumes || [],
            uniqueSeriesPlants(filteredSeries || []),
            state.info?.activeLanguages,
            state.affectedVehicles?.typeOfAffectedPlantsSelection,
          ),
          lastMSAdded: lastMSAdded || state.affectedVehicles?.lastMSAdded,
        },
      };
      break;
    }
    case COPY_VEHICLES_MODEL_DESIGNATION:
      newState = { copyVehicleModelDesignation: action.payload };
      break;
    case COPY_AGGREGATE:
      newState = { copyAggregate: action.payload };
      break;
    case MODIFY_CAMPAIGN_RECIPIENTS:
      newState = { recipients: action.payload };
      break;
    case MODIFY_CAMPAIGN_RISK_SCE_RELEVANCY:
      newState = { info: { ...state.info, riskPotentiallyRelevant: action.payload } };
      break;
    case MODIFY_CAMPAIGN_SUMMARY:
      newState = { summary: action.payload };
      break;
    case MODIFY_CAMPAIGN_PLANTFEEDBACK:
      newState = { plantFeedback: action.payload };
      break;
    case MODIFY_ORIGINAL_VALUES:
      newState = { originalValues: action.payload };
      break;
    case MODYFY_CAMPAIGN:
      newState = { ...action.payload };
      break;
    case SET_VALIDATIONS:
      newState = { validations: action.payload };
      break;
    case SET_CAMPAIGN_TRANSLATIONS:
      newState = {
        translations: action.payload,
        originalValues: {
          ...state.originalValues,
          hasChange: true,
        },
      };
      break;
    case SET_ACTIVE_VALIDATIONS_MIN:
      newState = {
        validations: {
          ...state.validations,
          active: {
            ...state.validations?.active,
            min: {
              ...state.validations?.min,
              [action.payload]: true,
            },
          },
        },
      };
      break;
    case SET_DESCRIPTION_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          description: action.payload,
        },
      };
      break;
    case SET_CLASSIFICATION_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          classification: action.payload,
        },
      };
      break;
    case SET_SOFTWARE_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          affectedSoftware: action.payload,
        },
      };
      break;
    case SET_RECIPIENTS_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          recipients: action.payload,
        },
      };
      break;
    case SET_AFFECTED_VEHICLES_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          affectedVehicles: action.payload,
        },
      };
      break;
    case SET_TRANSLATION_VALIDATIONS:
      newState = {
        validations: {
          ...state.validations,
          translations: action.payload,
        },
      };
      break;
    case SET_AFFECTED_VEHICLES_VOLUMES:
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          volumes: action.payload,
        },
      };
      break;
    case SET_VOLUMES_AND_ORIGIN_CHANGE:
      newState = {
        originalValues: action.payload.originalValues,
        affectedVehicles: {
          ...state.affectedVehicles,
          volumes: action.payload.volumes,
        },
      };
      break;
    case SET_VEHICLE_GROUPS: {
      const { plantSelected, groupId, groups } = action.payload;
      const volumes = putSelectionsVehicleGroupVolume(state.affectedVehicles.volumes, plantSelected, groupId, groups);
      // removed by the ticket CART-11200 we need a popup confirmation first
      // volumes = removeEmptyGroups(volumes, plantSelected.wkzNumber);

      newState = {
        originalValues: getOriginValuesNewState(state.originalValues, plantSelected),
        affectedVehicles: {
          ...state.affectedVehicles,
          volumes,
        },
      };
      break;
    }
    case SET_LIMITATION_PLANTS:
      newState = {
        limitationPlants: action.payload,
      };
      break;
    case SET_AFFECTED_PLANTS:
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          affectedPlants: action.payload,
        },
      };
      break;
    case UPDATE_PLANT: {
      const newPlants = [...state.affectedVehicles.affectedPlants];
      newPlants.splice(action.payload.index, 1, action.payload?.plant);
      const filteredPlant = newPlants.filter(({ plantName, affectedSeries }) => !(plantName && Object.keys(affectedSeries)?.length === 0));
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          affectedPlants: filteredPlant,
          volumes: addPlantsNotInVolumes(
            state.affectedVehicles?.volumes || [],
            filteredPlant || [],
            state.info.activeLanguages,
            state.affectedVehicles?.typeOfAffectedPlantsSelection,
          ),
        },
        ...(action.payload?.hasChange
          ? {
            originalValues: {
              ...state.originalValues,
              hasChange: true,
              changesIn: {
                ...state.originalValues?.changesIn,
                plants: true,
                volumes: {
                  ...state.originalValues.changesIn?.volumes,
                  [action.payload.plant.wkzNumber]: true,
                },
              },
            },
          }
          : {}),
      };
      break;
    }
    case ADD_SELECTED_PLANT:
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          affectedPlants: [...state.affectedVehicles.affectedPlants, { ...action.payload, affectedSeries: {} }],
        },
      };
      break;
    case SET_ONLY_PLANTS:
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          affectedPlants: action.payload?.map((plant) => ({ ...plant, affectedSeries: {} })),
        },
      };
      break;
    case SET_SELECTED_AFFECTED_VEHICLES:
      newState = {
        affectedVehicles: {
          ...state.affectedVehicles,
          typeOfAffectedPlantsSelection: action.payload,
        },
      };
      break;
    case SET_TRANSLATIONS:
      newState = {
        translations: Object.keys(action.payload.modules || {}).length === 1
          ? {
            ...state.translations,
            modules: {
              ...state.translations.modules,
              EXECUTIVE_SUMMARY: action.payload.modules.EXECUTIVE_SUMMARY,
            },
          }
          : action.payload,
        originalValues: {
          ...state.originalValues,
        },
      };
      break;
    case SET_PENDING_VOLUMES:
      newState = {
        arePendingVolumes: action.payload,
      };
      break;
    case SET_CAMPAIGN_CHANGES:
      newState = { changesFromVersion: action.payload };
      break;
    case SET_CAMPAIGN_SEARCH:
      newState = { campaignSearch: action.payload };
      break;
    case SET_CAMPAIGN_SEARCH_SELECTED_COINCIDENCE_FIELD_ID:
      newState = { campaignSearch: { ...state.campaignSearch, selectedCoincidenceFieldId: action.payload } };
      break;
    case SET_HIGHLIGHT_TAB:
      newState = { highlightTab: action.payload };
      break; default:
      newState = {};
  }

  return action.type === RESET_CAMPAIGN
    ? initialState()
    : {
      ...state,
      ...newState,
    };
};

export const getCampaign = (state) => state.campaignReducer;
export const getCampaignHelp = (state) => state.campaignReducer.help;
export const getCampaignHistory = (state) => state.campaignReducer.history;
export const getCampaignInfo = (state) => state.campaignReducer.info;
export const getCampaignDescription = (state) => state.campaignReducer.description;
export const getCampaignClassification = (state) => state.campaignReducer.classification;
export const getCampaignVehicles = (state) => state.campaignReducer.affectedVehicles;
export const getCampaignSoftware = (state) => state.campaignReducer.affectedSoftware;
export const getCampaignHardware = (state) => state.campaignReducer.affectedHardware;
export const getCampaignRecipients = (state) => state.campaignReducer.recipients;
export const getCampaingSummary = (state) => state.campaignReducer.summary;
export const getCampaingTranslations = (state) => state.campaignReducer.translations;
export const getCampaignAttachments = (state) => state.campaignReducer.attachments;
export const getOriginalValues = (state) => state.campaignReducer.originalValues;
export const getCampaignValidations = (state) => state.campaignReducer.validations;
export const getDescriptionValidations = (state) => state.campaignReducer.validations?.description;
export const getCampaignValidationsActive = (state) => state.campaignReducer.validations?.active;
export const getClassificationValidations = (state) => state.campaignReducer.validations?.classification;
export const getRecipientsValidations = (state) => state.campaignReducer.validations?.recipients;
export const getSoftwareValidations = (state) => state.campaignReducer.validations?.affectedSoftware;
export const getTranslationValidations = (state) => state.campaignReducer.validations?.translations;
export const getAreCampaignFormsInvalid = (state) => {
  const { validations, info } = state.campaignReducer;
  const forms = Object.keys(validations || {});
  const formsValidations = info.activeLanguages?.map(({ languageCode }) => (
    forms.some((form) => validations[form]?.[languageCode]?.invalid)
  ));

  return formsValidations?.some((inValid) => inValid);
};
export const getCampaignVehiclesVolumes = (state) => state.campaignReducer.affectedVehicles?.volumes;
export const getCampaignVehiclesSeries = (state) => state.campaignReducer.affectedVehicles?.series;
export const getCampaignVehiclesTechAssessment = (state) => state.campaignReducer.affectedVehicles?.technicalAssessment;
export const getCampaignCopyVehiclesModelDesignation = (state) => state.campaignReducer.copyVehicleModelDesignation;
export const getCampaignCopyVehiclesAggregate = (state) => state.campaignReducer.copyAggregate;
export const getVolumeHeaderPlants = (state) => uniqueSeriesPlants(state.campaignReducer.affectedVehicles?.series);
export const getAffectedVehiclesValidations = (state) => state.campaignReducer.validations?.affectedVehicles;
export const getLimitationPlants = (state) => state.campaignReducer.limitationPlants;
export const getSelectedPlants = (state) => state.campaignReducer.affectedVehicles?.affectedPlants || [];
export const getCampaignVehiclesSelectedAffectedVehicles = (state) => (
  state.campaignReducer?.affectedVehicles?.typeOfAffectedPlantsSelection
);
export const getArePendingVolumes = (state) => state.campaignReducer.arePendingVolumes || false;
export const getCampaingPlantFeedback = (state) => state.campaignReducer.plantFeedback;
export const getCampaignChanges = (state) => state.campaignReducer.changesFromVersion;
export const getCampaignSearch = (state) => state.campaignReducer.campaignSearch;
export const getIsVANCR = (state) => isVansBeforeFlowRemoval(state.campaignReducer?.info?.type, state.campaignReducer?.info?.creationDate);
export const getHighlightTab = (state) => state.campaignReducer.highlightTab;
